export const viewTitle = "Генерация массива ТК";
export const viewSecondTitle = "Генерация проектов описей дел";
export const viewThirdTitle = "Ответ на утвержденный проект описи дел";
export const viewFourthTitle = "Генерация ТК с ответом на обновление справочников";
export const viewSixthTitle = "Генерация Номенклатур";
export const viewSeventhTitle = "Генерация ТК с ответом от ГАС НСИ";
export const viewFifthTitle = "Запуск автоматических задач";
export const viewUniqKey = "TK-Generation";
